
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { 
  Select, 
  SelectContent, 
  SelectItem, 
  SelectTrigger, 
  SelectValue 
} from "@/components/ui/select";

interface ModelSelectProps {
  modelo: string;
  setModelo: (value: string) => void;
  setPersonalizado?: (value: boolean) => void;
  itens?: string[];
  categoria?: string;
  categorias?: { marca: string; modelos: string[] }[] | { categoria: string; itens: string[] }[];
  label?: string;
  placeholder?: string;
}

export const ModelSelect = ({ 
  modelo, 
  setModelo, 
  setPersonalizado, 
  itens,
  categoria,
  categorias,
  label = "Modelo",
  placeholder = "Selecione o modelo"
}: ModelSelectProps) => {
  // Determine which items to show based on props provided
  let itemsToShow: string[] = [];
  
  if (itens) {
    // Use the direct itens array if provided
    itemsToShow = itens;
  } else if (categorias && categoria) {
    // Check data structure type
    const isMarcaModelos = categorias.length > 0 && 'marca' in categorias[0];
    
    if (isMarcaModelos) {
      // Find the selected category in the marca/modelos structure
      const selectedCategory = (categorias as { marca: string; modelos: string[] }[])
        .find(cat => cat.marca === categoria);
      
      if (selectedCategory) {
        itemsToShow = selectedCategory.modelos;
      }
    } else {
      // Find the selected category in the categoria/itens structure
      const selectedCategory = (categorias as { categoria: string; itens: string[] }[])
        .find(cat => cat.categoria === categoria);
      
      if (selectedCategory) {
        itemsToShow = selectedCategory.itens;
      }
    }
  }

  return (
    <div className="grid gap-2">
      <div className="flex justify-between">
        <Label htmlFor="modelo">{label}</Label>
        {setPersonalizado && (
          <Button 
            type="button" 
            variant="link" 
            className="text-xs h-6 p-0"
            onClick={() => setPersonalizado(true)}
          >
            Item Personalizado
          </Button>
        )}
      </div>
      <Select
        value={modelo}
        onValueChange={setModelo}
      >
        <SelectTrigger id="modelo">
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          {itemsToShow.map((item) => (
            <SelectItem key={item} value={item}>
              {item}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
